/**
 * Adds invalid styling to specific form fields if error text is present.
 */
export class AppFormsValidator {

    initialize() {

        let errorQuery = '[aria-required="true"][data-sf-role="text-field-input"] ~ .invalid-feedback, [aria-required="true"][data-sf-role="dropdown-list-field-select"] ~ .invalid-feedback, [required="required"][data-sf-role="paragraph-text-field-textarea"] ~ .invalid-feedback';
        let formBuilderErrs = document.querySelectorAll(errorQuery);

        let config = { attributes: false, childList: true, subtree: true };

        var callback = function(mutationsList) {
            for (var i = 0; i < mutationsList.length; i++) {
                let formEl = document.querySelector(`[aria-describedby~="${mutationsList[i].target.id}"]`);
                if (mutationsList[i].target.textContent !== null && mutationsList[i].target.textContent !== '') {
                    formEl.classList.add('is-invalid');
                } else {
                    formEl.classList.remove('is-invalid');
                }
            }
        }

        for (let i = 0; i < formBuilderErrs.length; i++) {
            let observer = new MutationObserver(callback);

            observer.observe(formBuilderErrs[i], config);
        }
    }
}